import {z} from 'zod';

export const PrivateContentPerkContentTypeSchema = z.enum(['video', 'pdf']);
export type PrivateContentPerkContentType = z.infer<typeof PrivateContentPerkContentTypeSchema>;

export const PerkStatusSchema = z.enum(['live', 'archived', 'draft']);
export type PerkStatus = z.infer<typeof PerkStatusSchema>;

export const PerkTypeSchema = z.enum([
  'community',
  'conciergerie',
  'custom',
  'custom-product',
  'discount',
  'event-ticket',
  'exclusive-content',
  'limited-edition',
  'livestream',
  'pre-sale',
  'private-community',
  'private-sale',
  'promo-code',
  'survey',
  'VIP-support',
  'voting',
  'webinar',
  '1-1-meeting',
]);
export type PerkType = z.infer<typeof PerkTypeSchema>;
